import * as cellModule from './ActivePagesCell'
import { useCell } from 'src/lib/cellWrapper'

export default (props) => useCell(cellModule, props)
